export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  bm.add('player', {
    label: 'Player',
    category: 'Media',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true
      },
      void: true,
      type: 'player',
      style: {
        width: '30%',
        height: '30%'
      }
    },
    attributes: {
      class: 'fa fa-play' //icon in the panel
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/player/blocks.js